import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Mono-Code-ID mit Marken-Tint fuer die Uebersichtstabellen (NEX-1085).
 */
@Component({
  selector: 'app-code-id-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <code class="code-id-chip" data-testid="code-id-chip">{{ id() }}</code>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .code-id-chip {
      font-family: var(--font-mono);
      font-size: 0.75rem;
      font-weight: 600;
      color: var(--to-brand);
      background: var(--to-brand-tint);
      padding: 0.1875rem 0.5rem;
      border-radius: 0.3125rem;
      white-space: nowrap;
    }
  `,
})
export class CodeIdChipComponent {
  readonly id = input.required<string>();
}
